<template>
    <div>
        <Sidebar></Sidebar>

        <div class="content-wrapper content-wrapper-exemption">
            <div class="img-desktop img-desktop-create d-lg-inline-block"></div>

            <Header></Header>

            <section class="content create-due-content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-11 form-request-content-large">
                            <div class="request-title">
                                <h1>DUE : Créer</h1>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-10 form-request-content-large">
                          <ul class="breadcrumb-steps">
                            <li class="breadcrumb-steps__item success mobile-hide">
                              <span class="breadcrumb-steps__num"><i class='fas fa-check'></i></span>
                              <span class="breadcrumb-steps__descr">
                                Création du modèle de DUE
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item success mobile-hide">
                              <span class="breadcrumb-steps__num"><i class='fas fa-check'></i></span>
                              <span class="breadcrumb-steps__descr">
                                Paramétrage des bénéficiaires
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item success mobile-hide">
                              <span class="breadcrumb-steps__num"><i class='fas fa-check'></i></span>
                              <span class="breadcrumb-steps__descr">
                                Paramétrage des cotisations
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item success mobile-hide">
                              <span class="breadcrumb-steps__num"><i class='fas fa-check'></i></span>
                              <span class="breadcrumb-steps__descr">
                                Délais applicables
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item success">
                              <span class="breadcrumb-steps__num"><i class='fas fa-check'></i></span>
                              <span class="breadcrumb-steps__descr">
                                Cas de dispense facultatifs
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item active">
                              <span class="breadcrumb-steps__num">6</span>
                              <span class="breadcrumb-steps__descr">
                                Documents annexes
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item">
                              <span class="breadcrumb-steps__num">7</span>
                              <span class="breadcrumb-steps__descr">
                                Informations importantes
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item mobile-hide">
                              <span class="breadcrumb-steps__num">8</span>
                              <span class="breadcrumb-steps__descr">
                                Signature éléctronique
                              </span>
                            </li>
                          </ul>
                        </div>
                    </div>

                    <div class="col-md-10 form-request-content-large">
                        <div class="required-field-text">Champs obligatoires</div>
                        <div class="row">
                            <div class="col-md-8">
                                <div class="form-group">
                                    <form
                                            name="exemption"
                                            method="post"
                                            enctype="multipart/form-data"
                                            novalidate="novalidate"
                                            class="needs-validation"
                                    >

                                        <!-- Insurer name -->
                                        <div class="form-group">
                                            <label for="insurer-name"
                                                   class="required-field-asterisks"
                                            >Nom d'organisme assureur</label>
                                            <input type="text"
                                                   id="insurer-name"
                                                   class="form-control form-control-lg"
                                                   :class="{ 'is-invalid': $v.formData.insurerName.$error }"
                                                   @input="delayTouch($v.formData.insurerName)"
                                                   v-model="formData.insurerName"
                                            >
                                            <FormError v-if="$v.formData.insurerName.$error"
                                                       error="Veuillez saisir le nom d'organisme assureur"
                                            ></FormError>
                                            <p v-if="legalInformation"
                                               class="input-legend"
                                            >{{ legalInformation.insurerName.legalAdvice }}</p>
                                        </div>
                                        <!-- Insurer name -->

                                        <!-- Contract number -->
                                        <div class="form-group">
                                            <label for="contract-number"
                                                   class="required-field-asterisks"
                                            >N° du contrat</label>
                                            <input type="text"
                                                   id="contract-number"
                                                   class="form-control form-control-lg"
                                                   :class="{ 'is-invalid': $v.formData.contractNumber.$error }"
                                                   @input="delayTouch($v.formData.contractNumber)"
                                                   v-model="formData.contractNumber"
                                            >
                                            <FormError v-if="$v.formData.contractNumber.$error"
                                                       error="Veuillez saisir le numéro du contrat"
                                            ></FormError>
                                            <p v-if="legalInformation"
                                               class="input-legend"
                                            >{{ legalInformation.contractNumber.legalAdvice }}</p>
                                        </div>
                                        <!-- Contract number -->

                                        <!-- Products and options -->
                                        <div class="form-group">
                                            <label for="products-and-options"
                                                   class="required-field-asterisks"
                                            >Produits et options choisis</label>
                                            <input type="text"
                                                   id="products-and-options"
                                                   class="form-control form-control-lg"
                                                   :class="{ 'is-invalid': $v.formData.productsAndOptionsChosen.$error }"
                                                   @input="delayTouch($v.formData.productsAndOptionsChosen)"
                                                   v-model="formData.productsAndOptionsChosen"
                                            >
                                            <FormError v-if="$v.formData.productsAndOptionsChosen.$error"
                                                       error="Veuillez saisir le nom de l'option de garantie choisie"
                                            ></FormError>
                                            <p v-if="legalInformation"
                                               class="input-legend"
                                            >{{ legalInformation.productsAndOptionsChosen.legalAdvice }}</p>
                                        </div>
                                        <!-- Products and options  -->

                                        <!-- Contract start date -->
                                        <div class="form-group">
                                            <label for="contract-start-date"
                                                   class="required-field-asterisks"
                                            >Date de prise d'effet du contrat</label>
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">
                                                        <i class="far fa-calendar-alt"></i>
                                                    </span>
                                                </div>
                                                <masked-input type="text"
                                                              id="contract-start-date"
                                                              mask="11/11/1111"
                                                              class="form-control float-right"
                                                              :class="{ 'is-invalid': $v.formData.contractStartDate.$error }"
                                                              @input="maskedDelayTouch($v.formData.contractStartDate)"
                                                              v-model="formData.contractStartDate"
                                                />
                                            </div>
                                            <FormError error="Format de date incorrect"
                                                       v-if="!$v.formData.contractStartDate.validDate && $v.formData.contractStartDate.$dirty"
                                            ></FormError>
                                            <FormError error="Veuillez renseigner la date "
                                                       v-if="!$v.formData.contractStartDate.required && $v.formData.contractStartDate.$dirty"
                                            ></FormError>
                                            <FormError error="L'année indiquée n'est pas correcte"
                                                       v-if="!$v.formData.contractStartDate.isValidDateYear && $v.formData.contractStartDate.$dirty"
                                            ></FormError>
                                          <FormError error="La date de prise d'effet du contrat d'assurance doit être égale ou postérieure à la date de prise d'effet de la DUE"
                                                     v-if="!$v.formData.contractStartDate.dateSameOrAfterDate && $v.formData.contractStartDate.$dirty"
                                          ></FormError>
                                            <p v-if="legalInformation"
                                               class="input-legend"
                                            >{{ legalInformation.contractStartDate.legalAdvice }}</p>
                                        </div>
                                        <!-- Contract start date -->

                                        <!-- Table of benefits -->
                                        <div class="contract-input-group mt-4">
                                            <label for="table-of-benefits"
                                                   class="required-field-asterisks"
                                            >Les conditions particulières</label>
                                            <div>
                                                <span class="btn btn-primary btn-file">
                                                    <span v-if="!formData.particularConditions">Déposer la pièce justificative</span>
                                                    <span v-else>Changer de document</span>
                                                    <input type="file"
                                                           id="table-of-benefits"
                                                           @change="addDocument($event, 'particularConditions')"
                                                    >
                                                </span>
                                                <a v-if="formData.particularConditions"
                                                   href=""
                                                   download
                                                   class="ml-2"
                                                   @click.prevent="downloadDocument('particularConditions')"
                                                >{{ formData.particularConditions.name }}</a>
                                                <a v-if="formData.particularConditions"
                                                   class="close ml-2"
                                                   href=""
                                                   @click.prevent="deleteDocument('particularConditions')"
                                                >×</a>
                                                <FormError v-if="!$v.formData.particularConditions.validFileSize
                                                                 && !$v.formData.particularConditions.$dirty"
                                                           error="La taille du fichier ne doit pas dépasser 10MO"
                                                ></FormError>
                                                <FormError v-if="!$v.formData.particularConditions.validMimeType
                                                                 && !$v.formData.particularConditions.$dirty"
                                                           error="Les formats des fichiers autorisés sont .jpeg .jpg .pdf"
                                                ></FormError>
                                            </div>
                                        </div>
                                        <p v-if="legalInformation"
                                           class="input-legend"
                                        >{{ legalInformation.particularConditions.legalAdvice }}</p>

                                        <!-- Table of benefits -->

                                        <!-- Copy of information note -->
                                        <div class="contract-input-group">
                                            <label for="copy-of-information-note"
                                                   class="required-field-asterisks"
                                            >Copie de la notice d’information</label>
                                            <div>
                                                <span class="btn btn-primary btn-file">
                                                    <span v-if="!formData.copyOfInformationNote">Déposer la pièce justificative</span>
                                                    <span v-else>Changer de document</span>
                                                    <input type="file"
                                                           id="copy-of-information-note"
                                                           @change="addDocument($event, 'copyOfInformationNote')"
                                                    >
                                                </span>
                                                <a v-if="formData.copyOfInformationNote"
                                                   href=""
                                                   download
                                                   class="ml-2"
                                                   @click.prevent="downloadDocument('copyOfInformationNote')"
                                                >{{ formData.copyOfInformationNote.name }}</a>
                                                <a v-if="formData.copyOfInformationNote"
                                                   class="close ml-2"
                                                   href=""
                                                   @click.prevent="deleteDocument('copyOfInformationNote')"
                                                >×</a>
                                                <FormError v-if="!$v.formData.copyOfInformationNote.validFileSize
                                                                 && !$v.formData.copyOfInformationNote.$dirty"
                                                           error="La taille du fichier ne doit pas dépasser 10MO"
                                                ></FormError>
                                                <FormError v-if="!$v.formData.copyOfInformationNote.validMimeType
                                                                 && !$v.formData.copyOfInformationNote.$dirty"
                                                           error="Les formats des fichiers autorisés sont .jpeg .jpg .pdf"
                                                ></FormError>
                                            </div>
                                        </div>
                                        <p v-if="legalInformation"
                                           class="input-legend"
                                        >{{ legalInformation.copyOfInformationNote.legalAdvice }}</p>
                                        <!-- Copy of information note -->

                                        <!-- Is optional contract available -->
                                        <div class="form-group">
                                            <label class="required-field-asterisks"
                                                   for="is-optional-contract-available"
                                            >Parallèlement au contrat à adhésion obligatoire, proposez
                                              vous à vos salariés l'adhésion à un contrat à adhésion
                                              facultative ?</label>
                                            <select id="is-optional-contract-available"
                                                    class="form-control select2"
                                                    v-model="formData.isOptionalContractAvailable"
                                            >
                                                <option :value="true">Oui</option>
                                                <option :value="false">Non</option>
                                            </select>
                                            <p v-if="legalInformation"
                                               class="input-legend"
                                            >{{ legalInformation.isOptionalContractAvailable.legalAdvice }}</p>
                                        </div>
                                        <!-- Is optional contract available -->

                                        <!-- Optional contract number -->
                                        <div class="form-group" v-if="formData.isOptionalContractAvailable">
                                            <label for="optional-contract-number"
                                                   class="required-field-asterisks"
                                            >N° du contrat facultatif</label>
                                            <input type="text"
                                                   id="optional-contract-number"
                                                   class="form-control form-control-lg"
                                                   placeholder="N° du contrat (facultatif)"
                                                   :class="{ 'is-invalid': $v.formData.optionalContractNumber.$error }"
                                                   @input="delayTouch($v.formData.optionalContractNumber)"
                                                   v-model="formData.optionalContractNumber"
                                            >
                                            <FormError v-if="$v.formData.optionalContractNumber.$error"
                                                       error="Veuillez saisir le numéro du contrat facultatif"
                                            ></FormError>
                                            <p v-if="legalInformation"
                                               class="input-legend"
                                            >{{ legalInformation.optionalContractNumber.legalAdvice }}</p>
                                        </div>
                                        <!-- Optional contract number -->

                                        <!-- Employer contribution -->
                                        <div class="form-group" v-if="formData.isOptionalContractAvailable">
                                            <label for="employee-percents"
                                                   class="required-field-asterisks"
                                            >Part patronale pour le salarié</label>
                                            <input type="number"
                                                   id="employee-percents"
                                                   class="form-control form-control-lg"
                                                   placeholder="0%"
                                                   :class="{ 'is-invalid': $v.formData.employerContribution.$error }"
                                                   @input="delayTouch($v.formData.employerContribution)"
                                                   v-model.number="formData.employerContribution"
                                            >
                                            <FormError v-if="$v.formData.employerContribution.$error"
                                                       error="Ce champ indique un pourcentage, veuillez saisir une valeur etre 0 et 100"
                                            ></FormError>
                                            <p v-if="legalInformation"
                                               class="input-legend"
                                            >{{ legalInformation.employerContribution.legalAdvice }}</p>
                                        </div>
                                        <!-- Employer contribution -->

                                        <!-- Eligible parties contribution -->
                                        <div class="form-group" v-if="formData.isOptionalContractAvailable && due.isEligiblePartiesCanJoin">
                                            <label for="eligible-parties-percent"
                                                   class="required-field-asterisks"
                                            >Part patronale pour les ayants droit</label>
                                            <input type="number"
                                                   id="eligible-parties-percent"
                                                   class="form-control form-control-lg"
                                                   placeholder="0%"
                                                   :class="{ 'is-invalid': $v.formData.eligiblePartiesContribution.$error }"
                                                   @input="delayTouch($v.formData.eligiblePartiesContribution)"
                                                   v-model.number="formData.eligiblePartiesContribution"
                                            >
                                            <FormError v-if="$v.formData.eligiblePartiesContribution.$error"
                                                       error="Ce champ indique un pourcentage, veuillez saisir une valeur etre 0 et 100"
                                            ></FormError>
                                        </div>
                                        <!-- Eligible parties contribution -->

                                        <!-- Table of benefits facultative -->
                                        <div class="contract-input-group"
                                             v-if="formData.isOptionalContractAvailable"
                                        >
                                            <label for="table-of-benefits-facultative"
                                                   class="required-field-asterisks"
                                            >Les conditions particulières du contrat facultatif</label>
                                            <div>
                                                <span class="btn btn-primary btn-file">
                                                    <span v-if="!formData.particularConditionsForOptionalContract">Déposer la pièce justificative</span>
                                                    <span v-else>Changer de document</span>
                                                    <input type="file"
                                                           id="table-of-benefits-facultative"
                                                           @change="addDocument($event, 'particularConditionsForOptionalContract')"
                                                    >
                                                </span>
                                                <a v-if="formData.particularConditionsForOptionalContract"
                                                   href=""
                                                   download
                                                   class="ml-2"
                                                   @click.prevent="downloadDocument('particularConditionsForOptionalContract')"
                                                >{{ formData.particularConditionsForOptionalContract.name }}</a>
                                                <a v-if="formData.particularConditionsForOptionalContract"
                                                   class="close ml-2"
                                                   href=""
                                                   @click.prevent="deleteDocument('particularConditionsForOptionalContract')"
                                                >×</a>
                                                <FormError v-if="!$v.formData.particularConditionsForOptionalContract.validFileSize
                                                                 && !$v.formData.particularConditionsForOptionalContract.$dirty"
                                                           error="La taille du fichier ne doit pas dépasser 10MO"
                                                ></FormError>
                                                <FormError v-if="!$v.formData.particularConditionsForOptionalContract.validMimeType
                                                                 && !$v.formData.particularConditionsForOptionalContract.$dirty"
                                                           error="Les formats des fichiers autorisés sont .jpeg .jpg .pdf"
                                                ></FormError>
                                            </div>
                                        </div>
                                        <!-- Table of benefits facultative -->

                                        <!-- Copy of information note facultative -->
                                        <div class="contract-input-group"
                                            v-if="formData.isOptionalContractAvailable"
                                        >
                                            <label for="copy-of-information-note-facultative"
                                                   class="required-field-asterisks"
                                            >La notice d'information du contrat facultatif</label>
                                            <div>
                                                <span class="btn btn-primary btn-file">
                                                    <span v-if="!formData.copyOfInformationNoteForOptionalContract">Déposer la pièce justificative</span>
                                                    <span v-else>Changer de document</span>
                                                    <input type="file"
                                                           id="copy-of-information-note-facultative"
                                                           @change="addDocument($event, 'copyOfInformationNoteForOptionalContract')"
                                                    >
                                                </span>
                                                <a v-if="formData.copyOfInformationNoteForOptionalContract"
                                                   href=""
                                                   download
                                                   class="ml-2"
                                                   @click.prevent="downloadDocument('copyOfInformationNoteForOptionalContract')"
                                                >{{ formData.copyOfInformationNoteForOptionalContract.name }}</a>
                                                <a v-if="formData.copyOfInformationNoteForOptionalContract"
                                                   class="close ml-2"
                                                   href=""
                                                   @click.prevent="deleteDocument('copyOfInformationNoteForOptionalContract')"
                                                >×</a>
                                                <FormError v-if="!$v.formData.copyOfInformationNoteForOptionalContract.validFileSize
                                                                 && !$v.formData.copyOfInformationNoteForOptionalContract.$dirty"
                                                           error="La taille du fichier ne doit pas dépasser 10MO"
                                                ></FormError>
                                                <FormError v-if="!$v.formData.copyOfInformationNoteForOptionalContract.validMimeType
                                                                 && !$v.formData.copyOfInformationNoteForOptionalContract.$dirty"
                                                           error="Les formats des fichiers autorisés sont .jpeg .jpg .pdf"
                                                ></FormError>
                                            </div>
                                        </div>
                                        <!-- Copy of information note facultative  -->
                                    </form>
                                </div>
                            </div>
                            <div class="col-md-4 col-xl-3 info-card due-sixth-step-card">
                                <span class="badge badge-danger">PDF</span>
                                <h5 class="mt-2">
                                    <template v-if="Object.keys(due).length > 0 && due.collectiveAgreement.id === 54">
                                        <span v-text="`DUE neutre: ${ (due.collectiveAgreement.name).toLowerCase() }`"
                                        ></span>
                                    </template>

                                    <template v-else-if="Object.keys(due).length > 0">
                                        <span>DUE: </span>
                                        <span v-text="`${ due.collectiveAgreement.codeIdcc } ${ due.collectiveAgreement.name }`"
                                        ></span>
                                    </template>

                                </h5>
                                <div class="intro">Attention ce document n'a pas encore de valeur juridique</div>
                                <img src="@/assets/img/orangePill.svg" class="due-document-orange-pill">
                                <button class="btn__export--due"
                                        :disabled="!due || downloadDueIsLoading"
                                        @click="downloadDuePdf"
                                >
                                    <span>Consulter</span>
                                    <ButtonSpinner :isLoading="downloadDueIsLoading"></ButtonSpinner>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="input-group col-md-10 mx-sm-auto my-md-4">
                        <div class="mx-sm-auto">
                            <button class="btn btn-lg btn-link btn__primary"
                                    :disabled="saveIsLoading || nextStepIsLoading"
                                    @click.prevent="toPreviousStep('due-fifth-step')"
                            >
                                <span>Revenir à l'étape précédente</span>
                            </button>

                            <button class="btn btn-success btn-lg ml-4 btn-link btn__save"
                                    :disabled="saveIsLoading || nextStepIsLoading"
                                    @click.prevent="saveDue()"
                            >
                                <span>Enregistrer le brouillon</span>
                                <ButtonSpinner :isLoading="saveIsLoading"></ButtonSpinner>
                            </button>
                        </div>
                    </div>

                    <div class="input-group mx-sm-auto">
                        <div class="large-btn__box">
                            <button class="btn btn-success btn-lg btn-link btn__save--large"
                                    :disabled="$v.$invalid || saveIsLoading || nextStepIsLoading"
                                    @click.prevent="saveAndMoveForward('due-seventh-step')"
                            >
                                <span>Enregistrer les modifications</span>
                                <ButtonSpinner :isLoading="nextStepIsLoading"></ButtonSpinner>
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import Sidebar from '../../../components/Sidebar';
    import Footer from '../../../components/Footer';
    import ButtonSpinner from '../../../components/ButtonSpinner';
    import DueStepsNavigation from '../../../mixins/dueStepsNavigation';
    import DueSixthStepManager from '../../../service/manager/due/sixthStepManager';
    import DueDocumentManager from '../../../mixins/dueDocumentManager';
    import ValidationDelayTouch from '../../../mixins/validationDelayTouch';
    import Header from '../../../components/Header';
    import FormError from '../../../components/FormError';
    import MaskedInput from 'vue-masked-input';
    import { mapActions, mapGetters } from 'vuex';
    import { maxValue, minValue, required } from 'vuelidate/lib/validators';
    import { downloadFile } from '../../../utils/utils';
    import {
        fileMineTypeConstraint,
        filesizeConstraint,
        validDateConstraint,
        isValidDateYearConstraint,
        dateSameOrAfterDateConstraint
    } from '../../../utils/validation';
    import ScrollToMixin from "@/mixins/scrollToMixin";

    export default {
        mixins: [DueStepsNavigation, DueDocumentManager, ValidationDelayTouch, ScrollToMixin],
        data() {
            return {
                formData: {
                    insurerName: '',
                    contractNumber: '',
                    productsAndOptionsChosen: '',
                    contractStartDate: '',
                    particularConditions: null,
                    copyOfInformationNote: null,
                    isOptionalContractAvailable: null,
                    optionalContractNumber: '',
                    employerContribution: null,
                    eligiblePartiesContribution: null,
                    particularConditionsForOptionalContract: null,
                    copyOfInformationNoteForOptionalContract: null,
                },
                saveIsLoading: false,
                nextStepIsLoading: false,
                downloadDueIsLoading: false
            };
        },
        computed: {
            ...mapGetters({
                due: 'due',
                legalInformation: 'legalInformation'
            })
        },
        async mounted() {
            await this.fetchDue();
            await this.fetchDueLegalInformation();
            await this.setCurrentStep(6);
            this.scrollTo();
        },
        methods: {
            ...mapActions({
                setCurrentStep: 'setCurrentStep',
                fetchCurrentDue: 'fetchCurrentDue',
                updateCurrentDue: 'updateCurrentDue',
                fetchDueLegalInformation: 'fetchDueLegalInformation'
            }),
            async fetchDue() {
                await this.fetchCurrentDue(this.$route.params.id);
                this.formData = {
                    ...this.formData,
                    ... await DueSixthStepManager.createFormDataFromResponse(this.due)
                };
            },
            addDocument(event, documentType) {
                this.formData[documentType] = event.target.files[0];
            },
            deleteDocument(documentName) {
                this.formData[documentName] = null;
            },
            async prepareRequest() {
                const additionalFormData = {
                    propertiesToNull: []
                };

                return await DueSixthStepManager.createSixthOrAmendmentStepUpdateRequest(
                    this.formData,
                    additionalFormData
                );
            },
            async downloadDocument(documentName) {
                await downloadFile({
                    content: this.formData[documentName]
                });
            },
        },
        validations() {
            let validations = {
                formData: {
                    insurerName: {
                        required
                    },
                    contractNumber: {
                        required
                    },
                    productsAndOptionsChosen: {
                        required
                    },
                    contractStartDate: {
                        required,
                        validDate: validDateConstraint,
                        isValidDateYear: isValidDateYearConstraint,
                        dateSameOrAfterDate: dateSameOrAfterDateConstraint(this.due.effectStartDate)
                    },
                    particularConditions: {
                        required,
                        validFileSize: filesizeConstraint(10000000),
                        validMimeType: fileMineTypeConstraint(['image/jpeg', 'image/png', 'application/pdf'])
                    },
                    copyOfInformationNote: {
                        required,
                        validFileSize: filesizeConstraint(10000000),
                        validMimeType: fileMineTypeConstraint(['image/jpeg', 'image/png', 'application/pdf'])
                    },
                    isOptionalContractAvailable: {
                        required
                    }
                }
            }

            if (this.formData.isOptionalContractAvailable) {
                validations.formData.optionalContractNumber = {
                    required
                };
                validations.formData.employerContribution = {
                    required,
                    minValue: minValue(0),
                    maxValue: maxValue(100)
                };
                validations.formData.particularConditionsForOptionalContract = {
                    required,
                    validFileSize: filesizeConstraint(10000000),
                    validMimeType: fileMineTypeConstraint(['image/jpeg', 'image/png', 'application/pdf'])
                }
                validations.formData.copyOfInformationNoteForOptionalContract = {
                    required,
                    validFileSize: filesizeConstraint(10000000),
                    validMimeType: fileMineTypeConstraint(['image/jpeg', 'image/png', 'application/pdf'])
                }
            }

            if (this.due.isEligiblePartiesCanJoin && this.formData.isOptionalContractAvailable) {
                validations.formData.eligiblePartiesContribution = {
                    required,
                    minValue: minValue(0),
                    maxValue: maxValue(100)
                }
            }

            return validations;
        },
        components: {
            Header,
            Sidebar,
            Footer,
            ButtonSpinner,
            FormError,
            MaskedInput
        }
    }
</script>
